/* eslint-disable no-sequences */
/* eslint-disable eqeqeq */
import React, { useState, useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
// icons
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import Alert from '@material-ui/lab/Alert';

// components
import CardTitle from 'src/components/sharedComponents/CardTitle';
import { ScreenLoading2 } from 'src/components/sharedComponents/ScreenLoading/index';
import CustomInput from 'src/components/sharedComponents/CustomInput/CustomInput';
import Card from 'src/components/sharedComponents/Card/Card';
import CardHeader from 'src/components/sharedComponents/Card/CardHeader';
import CardFooter from 'src/components/sharedComponents/Card/CardFooter';
import CardBody from 'src/components/sharedComponents/Card/CardBody';
import CardIcon from 'src/components/sharedComponents/Card/CardIcon';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import PermisosList from 'src/components/adminCenter/UserPermitsList';
import UserPermitsUnits from 'src/components/adminCenter/UserPermitsUnits';
import { permitsList, minPermisos } from 'src/constants/permits';
// context
import { Context } from 'src/context/Contex';

const UsersPermits = ({
  user = {},
  permits = [],
  unitsUser = [],
  units = [],
  permit = {},
  onUpdatePass,
  onUpdateUser,
  onDeleteUnit,
  onUpdateUnit,
  onUpdatePermit,
  onDeletePermit,
}) => {
  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [password, setPassword] = useState('');
  const [mail, setMail] = useState('');
  const [error, setError] = useState(false);
  const [check, setCheck] = useState(false);
  const { permisos } = useContext(Context);

  const minValue = permisos && permisos[permitsList.ADMIN_USUARIOS];
  const permitFlag = permisos && permisos[permitsList.ADMIN_PERMISOS];

  const mensaje = 'La contraseña debe tener al menos 8 caracteres';
  const dateFix = moment
    .utc(user.ultimo_ingreso, 'YYYY-MM-DD HH:mm:ss.SSSS')
    .local()
    .format('YYYY-MM-DD HH:mm');

  const hanldeChange = (event) => {
    setPassword(event.target.value);
    if (event.target.value.length < 0) {
      return setError(false), setCheck(false);
    }
    if (event.target.value.length >= 8) {
      return setError(false), setCheck(true);
    }
    return setError(true);
  };

  const handleClick = (event) => {
    event.preventDefault();
    onUpdatePass({
      clave: password,
      id: user.id,
    });
  };

  const handlerSubmit = (event) => {
    event.preventDefault();
    onUpdateUser({
      correo: mail || user.correo,
      nombre: name || user.nombre,
      apellido: lastName || user.apellido,
      id: user.id,
    });
  };

  if (!user || !units || !unitsUser || !user.id) return <ScreenLoading2 />;
  return (
    <main style={{ margin: '10px' }}>
      <CardTitle title="Asignación de permisos" />
      <Alert severity="info">
        Último ingreso:
        <strong>{dateFix}</strong>
      </Alert>
      {minValue >= minPermisos.VISUALIZAR || null ? (
        <Grid justifyContent="center" container spacing={2}>
          <Grid item xs={12} md={8} sm={6}>
            <form onSubmit={handlerSubmit}>
              <Card>
                <CardHeader color="customAuteco" stats icon>
                  <CardIcon color="customAuteco">
                    <ContactMailIcon />
                  </CardIcon>
                </CardHeader>
                <CardBody>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={4} sm={12}>
                      <CustomInput
                        labelText="Nombre"
                        id="name"
                        value={name}
                        formControlProps={{
                          required: true,
                          fullWidth: true,
                        }}
                        inputProps={{
                          onChange: (event) => setName(event.target.value),
                          type: 'text',
                          autoComplete: 'off',
                          defaultValue: user.nombre,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={4} sm={12}>
                      <CustomInput
                        labelText="Apellido"
                        id="lastname"
                        value={lastName}
                        required
                        formControlProps={{
                          required: true,
                          fullWidth: true,
                        }}
                        inputProps={{
                          onChange: (event) => setLastName(event.target.value),
                          type: 'text',
                          autoComplete: 'off',
                          defaultValue: user.apellido,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={4} sm={12}>
                      <CustomInput
                        labelText="Correo"
                        id="correo"
                        value={mail}
                        required
                        formControlProps={{
                          required: true,
                          fullWidth: true,
                        }}
                        inputProps={{
                          onChange: (event) => setMail(event.target.value),
                          type: 'email',
                          defaultValue: user.correo,
                        }}
                      />
                    </Grid>
                  </Grid>
                </CardBody>
                <CardFooter>
                  <Button type="onSubmit " color="warning">
                    Actualizar Datos
                  </Button>
                </CardFooter>
              </Card>
            </form>
          </Grid>
          <Grid item xs={12} md={4} sm={6}>
            <Card>
              <CardHeader color="customAuteco" stats icon>
                <CardIcon color="customAuteco">
                  <VpnKeyIcon />
                </CardIcon>
              </CardHeader>
              <CardBody>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <CustomInput
                      labelText="Contraseña"
                      id="password"
                      value={password}
                      error={error}
                      success={check}
                      required
                      formControlProps={{
                        required: true,
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: 'text',
                        onChange: hanldeChange,
                        autoComplete: 'off',
                      }}
                    />
                    {error && <p>{mensaje}</p>}
                  </Grid>
                </Grid>
              </CardBody>
              <CardFooter>
                <Button onClick={handleClick} color="warning" disabled={error}>
                  Actualizar Contraseña
                </Button>
              </CardFooter>
            </Card>
          </Grid>
          <div />
        </Grid>
      ) : null}
      {permitFlag >= minPermisos.VISUALIZAR || null ? (
        <Grid item xs={12}>
          <Card>
            <CardHeader color="customAuteco" stats icon>
              <CardIcon color="customAuteco">
                <AccountTreeIcon />
              </CardIcon>
            </CardHeader>
            <CardBody>
              <Grid container justifyContent="center">
                <FormControl>
                  <FormLabel component="legend">
                    Asigne una unidad de Negocio
                  </FormLabel>
                  <FormGroup row>
                    <UserPermitsUnits
                      user={user}
                      units={units}
                      unitsUser={unitsUser}
                      onDeleteUnit={onDeleteUnit}
                      onUpdateUnit={onUpdateUnit}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </CardBody>
          </Card>
        </Grid>
      ) : null}
      {permitFlag >= minPermisos.VISUALIZAR || null ? (
        <Grid item xs={12}>
          <Card>
            <CardHeader color="customAuteco" stats icon>
              <CardIcon color="customAuteco">
                <LockOpenIcon />
              </CardIcon>
            </CardHeader>
            <CardBody>
              <Grid container justifyContent="center">
                <FormControl>
                  <FormLabel component="legend">
                    Zona de asignación de permisos
                  </FormLabel>
                  <FormGroup>
                    <PermisosList
                      permits={permits}
                      permit={permit}
                      onUpdatePermit={onUpdatePermit}
                      onDeletePermit={onDeletePermit}
                      user={user}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </CardBody>
          </Card>
        </Grid>
      ) : null}
    </main>
  );
};

export default UsersPermits;
